import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import classnames from "classnames";
import Link from "next/link";
import React from "react";
import NewLabel from "../new-label/NewLabel";
import styles from "./OptionButton.module.scss";

function OptionButton({
  title,
  className,
  contentClassName,
  imgSrc,
  imgAlt,
  imgContainerClassName,
  imgClassName,
  onClick,
  href,
  isNew = false,
}) {
  return (
    <Link href={href} shallow scroll>
      <SecondaryButton
        className={classnames(styles.button, styles.button2, className, !imgSrc ? styles.buttonOnlyText : "")}
        onClick={onClick}
      >
        {isNew && <NewLabel className={classnames(styles.newLabel, styles.newLabel_desktop)} />}
        <div className={classnames(styles.__content, contentClassName)}>
          <div className={imgContainerClassName}>
            {imgSrc && <img src={imgSrc.src} alt={imgAlt || title} className={imgClassName} />}
          </div>
          <div>
            {isNew && <NewLabel className={classnames(styles.newLabel, styles.newLabel_mobile)} />}
            <span className={styles.__text}>{title}</span>
          </div>
        </div>
        <div className={styles.__chevron}>
          <ChevronRight />
        </div>
      </SecondaryButton>
    </Link>
  );
}

export default OptionButton;
